import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Checkbox.scss';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

const CheckBoxSimples = props => {

    const checked = props.checked ? true : false;
    const [valueCheck, setValueCheck] = useState(checked);

    const setValue = bool => {

        setValueCheck(bool);
        if(props.callback) {
            if(props.callbackArgs !== undefined){
                props.callback(props.value, bool, props.callbackArgs);
            } else {
                props.callback(props.value, bool);
            }
        }
    }

    const isChecked = () => {
        return props.reload ? props.checked : valueCheck;
    }

    return (
        <div className="checkboxSimples">
            <div onClick={() => setValue(!isChecked())}>
                {props.showIcon && isChecked() && <FontAwesomeIcon icon={faCheckSquare} />}
                {props.showIcon && !isChecked() && <FontAwesomeIcon icon={faSquare} />}
            </div>
        </div>
    );
};

export default CheckBoxSimples;